document.addEventListener( 'DOMContentLoaded', function () {
	'use strict';
	// Breakpoints matching theme breakpoints.
	const mdBreakpoint = window.matchMedia( '(min-width: 768px)' );

	function handleScreenSize() {
		const toggleButtons = document.querySelectorAll(
			'[data-pricing-toggle="features"]'
		);

		toggleButtons.forEach( ( button ) => {
			const featuresContainer = button.closest( '.features' );
			const hiddenFeatures =
				featuresContainer.querySelectorAll( '.feature-hidden' );

			if ( mdBreakpoint.matches ) {
				// Screen is md or larger - show all features, hide button.
				hiddenFeatures.forEach( ( feature ) => {
					feature.classList.remove( 'd-none' );
				} );
				button.style.display = 'none';
			} else {
				// Screen is smaller than md - show button, reset to collapsed state.
				button.style.display = 'block';
				hiddenFeatures.forEach( ( feature ) => {
					feature.classList.add( 'd-none' );
				} );
				button.textContent = 'See More';
			}
		} );
	}

	// Handle "See More/See Less" feature toggle only on small screens.
	const toggleButtons = document.querySelectorAll(
		'[data-pricing-toggle="features"]'
	);

	toggleButtons.forEach( ( button ) => {
		button.addEventListener( 'click', function ( e ) {
			e.preventDefault();

			// Only work if screen is smaller than md.
			if ( mdBreakpoint.matches ) {
				return;
			}

			const isExpanded = this.textContent.trim() === 'See Less';

			// Find the carousel or container that holds all pricing items.
			const carouselContainer =
				this.closest( '.carousel-items' ) ||
				this.closest( '.pricing-items' ) ||
				document;

			// Find all pricing items in the same level/container
			const allToggleButtons = carouselContainer.querySelectorAll(
				'[data-pricing-toggle="features"]'
			);

			// Expand/collapse ALL pricing items together.
			allToggleButtons.forEach( ( toggleBtn ) => {
				const featuresContainer = toggleBtn.closest( '.features' );
				const hiddenFeatures =
					featuresContainer.querySelectorAll( '.feature-hidden' );

				if ( isExpanded ) {
					// Hide extra features (collapse to 5).
					hiddenFeatures.forEach( ( feature ) => {
						feature.classList.add( 'd-none' );
					} );
					toggleBtn.textContent = 'See More';
				} else {
					// Show all features.
					hiddenFeatures.forEach( ( feature ) => {
						feature.classList.remove( 'd-none' );
					} );
					toggleBtn.textContent = 'See Less';
				}
			} );
		} );
	} );

	// Listen for screen size changes.
	mdBreakpoint.addEventListener( 'change', handleScreenSize );

	// Initialize on page load.
	handleScreenSize();
} );
